module.exports = __webpack_public_path__ + "img/ry_lc.2c685965.png";